import React from "react";
// import MainSlider from '../ComponentsAdi/MainSlider'
// import WhatsNew from '../ComponentsAdi/WhatsNew'
// import Welcome from '../ComponentsAdi/Welcome'
// import HomeBench from '../ComponentsAdi/HomeBench'
// import NewsNotification from '../ComponentsAdi/NewsNotification/NewsNotification'
// import NoticeSection from '../ComponentsAdi/NoticeSection'
// import MediaSection from '../ComponentsAdi/MediaSection/MediaSection'
// import BottomNavSection from '../ComponentsAdi/BottomNavSection'

import WhatsNew from "../../../../Frontend/Container/pages/Home/WhatsNew";
import CaseManagementHome from "../../../../Frontend/Container/pages/Home/CaseManagementHome/CaseManagementHome";
import UsefulLinks from "../../../../Frontend/Container/pages/Home/CaseManagementHome/UsefulLinks";
import HomeBanner from "../../../../Frontend/Container/pages/Home/HomeBanner";

function HomeJaipur({ benchId, benchName }) {
  return (
    <>
      <div className="col-12 col-sm-12 col-md-6 col-lg-6">
        {/* <div className="home-banner-bench">{benchName} BENCH</div>  */}
        <HomeBanner benchId={7} />
        {/* <WhatsNew benchId={7} /> */}
        <CaseManagementHome />
      </div>
      <UsefulLinks />
    </>
  );
}

export default HomeJaipur;
